import { connect } from 'react-redux'
import PageNeighborhoods from './PageNeighborhoodView.component'
import * as urls from '../../../../constants/api'
import { loadPropertiesByNeighborhood, loadSimilarProperties, load } from '../../../../actions/propiedades'
import { loadNeighborhoodDetails, loadCaracteristics, resetPlaces } from '../../../../actions/neighborhoodFront'

const mapStateToProps = (state) => {
  return {
    propertiesList: state.propiedades.importantList,
    similarList: state.propiedades.similarProperties,
    neighborhood: state.neighborhoodFront.detail,
    totalRent: state.neighborhoodFront.totalRent,
    totalSale: state.neighborhoodFront.totalSale,
    totalNeighborhoodRent: state.neighborhoodFront.neighborhoodRent,
    totalNeighborhoodSale: state.neighborhoodFront.neighborhoodSale,
    places: state.neighborhoodFront.places
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPlaces: () => dispatch(resetPlaces()),
    loadNeighborhoodDetails: id => {
      dispatch(loadNeighborhoodDetails(id))
      dispatch(loadCaracteristics(id))
    },
    loadProperties: id => {
      dispatch(loadSimilarProperties(id))
      dispatch(loadPropertiesByNeighborhood(id))
    },
    findProperties: () =>{
      dispatch(load(urls.NEIGHBORHOODS))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageNeighborhoods)


// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/components/NeighborhoodView/PageNeighborhoodView.container.js